import * as React from 'react';

export const NavigationRefs = {
  Overview: React.createRef<any>(),
  Offers: React.createRef<any>(),
  Location: React.createRef<any>(),
  Amenities: React.createRef<any>(),
  Policies: React.createRef<any>(),
  Reviews: React.createRef<any>()
};
